import React from 'react';
import { usePermitRequestContext } from '../../../../contexts/PermitRequestContext';
import { useTags } from '../../../../hooks/useTags';
import addRequestPageLang from '../../../../data/lang/add-request-page.lang';
import formErrorsLang from '../../../../data/lang/form-errors.lang';
import Style from '../../style.module.scss';


const TakanonCheckBox = () => {

    const { Formik } = usePermitRequestContext();

    const { handleBlur, errors, touched, setFieldValue } = Formik;
    const errorMsg = errors.agreeTakanon && touched.agreeTakanon ? errors.agreeTakanon : undefined;

    const generateTag = useTags();
    const takanonTitleTag = generateTag(addRequestPageLang, 'takanon.takanon-check-box');
    const checkboxTakanonError = generateTag(formErrorsLang, errorMsg || '');


    return (
        <div>
            <span className={Style.checkInputForm}>
                <input
                    onBlur={handleBlur}
                    onChange={event => setFieldValue('agreeTakanon', event.currentTarget.checked ? 1 : 0)}
                    id={`agreeTakanonid`}
                    name='agreeTakanon'
                    className="form-check-input"
                    type='checkbox'
                />
                <label className="form-check-label" htmlFor={`agreeTakanonid`}>
                    {takanonTitleTag}
                </label>
            </span>
            {errorMsg ? <div className={Style.errMsgTakanon}> {checkboxTakanonError} </div> : ''}
        </div>
    );
}

export default TakanonCheckBox;